import { ChatWithShortInfo } from "@sms/shared/chat/chat.interface";
import { eventChannel } from "redux-saga";
import { io, Socket } from "socket.io-client";

import { BASE_URL_WS } from "../utils/api-fetch";

import chatEntryActions from "./chat.entry-actions";

export const createSocketEventsChatsChannel: any = (): any =>
  eventChannel(emit => {
    socketChats.on("connect", () => emit(chatEntryActions.handleConnectSocketChat()));

    socketChats.on("reconnect", () => emit(chatEntryActions.handleReconnectSocketChat()));

    socketChats.on("recieveCountChatsAllNotifications", (data: number) =>
      emit(chatEntryActions.handleCountAllNotification(data))
    );

    socketChats.on("updateChat", (chat: ChatWithShortInfo) => emit(chatEntryActions.handleUpdateChat(chat)));

    socketChats.on("createChat", (chat: ChatWithShortInfo) => emit(chatEntryActions.handleUpdateChat(chat)));

    return (): void => {
      socketChats.off("connect");
      socketChats.off("recieveCountChatsAllNotifications");
      socketChats.off("updateChat");
      socketChats.off("createChat");
    };
  });

export let socketChats: Socket;

export function connectSocketChat(): Socket {
  socketChats = io(`${BASE_URL_WS}/chat`, {
    transports: ["websocket"]
  });

  return socketChats;
}
